import React from 'react'
import cn from 'classnames'
import Center from './Center'
import Left from './Left'
import Menu from './Menu'
import MenuLink from './MenuLink'
import classes from './Navigation.module.scss'
import Right from './Right'
import Title from './Title'

export type NavigationProps = React.HTMLAttributes<HTMLHeadingElement> & {
  background?: 'solid' | 'gradient' | 'transparent' | 'themed'
  children?: React.ReactNode
  className?: string
  navChildClassName?: string
  contained?: boolean
}

const Navigation = ({
  background = 'solid',
  children,
  className,
  navChildClassName,
  contained = true,
  ...props
}: NavigationProps) => {
  const backgrounds = {
    solid: 'mc-background--color-dark mc-theme-dark',
    gradient: classes.backgroundGradient,
    transparent: null,
    themed: classes.themedNav,
  }

  return (
    <header className={cn(backgrounds[background], className)} {...props}>
      <div className={contained ? 'container' : 'container-fluid'}>
        <div
          className={cn(
            classes.height,
            navChildClassName,
            'row no-gutters-vertical align-items-center justify-content-between',
          )}
        >
          {children}
        </div>
      </div>
    </header>
  )
}

Navigation.Menu = Menu
Navigation.MenuLink = MenuLink
Navigation.Title = Title
Navigation.Left = Left
Navigation.Center = Center
Navigation.Right = Right

export default Navigation
